import { Component, OnInit, Input, ɵConsole } from '@angular/core';
import { attendanceService, ClassesService, StudyTableService } from 'src/app/_services';
import {
  AttendanceStatusBackend,
  Section,
  AttendanceRegisterStudents,
  AttendanceRegister,
  AttendanceSearchModel,
  RegisterAttendanceModel,
  AttendanceSession,
  ScheduleCategoryAuto,
  KeyValuePair,
  ViewSchedulePeriods,
  CategoryDays
} from 'src/app/_models';
import { Badge } from 'src/app/templates/models/badge.interface';
import { BaseComponent } from 'src/app/_base/base.component';
import * as moment from 'moment';
import { SchoolClass } from 'src/app/templates/models/schoolClass.interface';
import { AttendanceMethodTypes } from 'src/app/_enums';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent extends BaseComponent implements OnInit {
  @Input()
  isFromLMS: boolean = false;
  isBusy: boolean;
  registerBadgeStatuses: Badge[] = [];
  badgeStatuses: Badge[] = [];
  attendanceStatus: AttendanceStatusBackend[];
  students: AttendanceRegisterStudents[] = [];
  isHoliday: boolean = false;
  statusId: number = null;
  presentStatusId: number = null;
  dropDownChanged: boolean = false;
  class: SchoolClass = null;
  sections: Section[] = [];
  sessions: AttendanceSession[] = [];
  periods: ViewSchedulePeriods[] = [];
  schoolDays: number[] = []; // List Of Selected Days From Study Table.
  registerAttendanceModel: RegisterAttendanceModel;
  attendanceSearchModel: AttendanceSearchModel = {
    attendanceSessionId: null,
    classId: null,
    date: moment()
      .locale('en')
      .format('YYYY-MM-DD'),
    sectionId: null,
    schoolPeriodAllocationId: null,
    semesterId: this.mainFilterSvc.globalFilterObj.academicSemesterId
  };
  isNotified = false;
  sectionIdParams: number = null;
  dateParams: string = null;
  loaderActive: boolean = false;
  constructor(
    private attendanceServices: attendanceService,
    private studyTableService: StudyTableService,
    private classesService: ClassesService,
    private route: ActivatedRoute // private languageService: LanguageService
  ) {
    super();
    // this.languageService.LangNotefier.subscribe(() => this.badgesInit());
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (!params) return;
      if (params.date) {
        this.dateParams = moment(params.date)
          .locale('en')
          .format('YYYY-MM-DD');
      }
      if (params.sectionId) {
        this.sectionIdParams = Number(params.sectionId);
      }
    });
  }
  badgesInit(): void {
    this.registerBadgeStatuses = [];
    this.attendanceServices.getAllAttendanceStatus().subscribe(
      (data: AttendanceStatusBackend[]) => {
        data.map(item => {
          this.registerBadgeStatuses.push({
            id: item.attendanceStatusId,
            name: item.attendanceStatusName,
            nameEn: item.attendanceStatusNameEn,
            color: item.color,
            value: this.students.filter(itemFilter => itemFilter.statusId === item.attendanceStatusId).length
          });
          // BaseComponent.spinner.isActive = false;
          if (this.registerBadgeStatuses.length > 0) this.presentStatusId = this.registerBadgeStatuses[0].id;
          if (this.isHoliday) if (this.registerBadgeStatuses.length > 0) this.registerBadgeStatuses[0].value = 0;
        });
        this.badgeStatuses = [...this.registerBadgeStatuses];
        this.registerBadgeStatuses.splice(0, 0, {
          id: -1,
          name: 'AttendanceModule.ClassStudents',
          color: '#0aa9c6',
          value: this.students.length
        });
        this.loaderActive = false;
      },
      () => {
        this.loaderActive = false;
      }
    );
  }
  statusChanger(statusUpdate: { studentId: string; statusId: number }): void {
    const currentStatusIndex = this.badgeStatuses.findIndex(item => item.id === statusUpdate.statusId);
    const studentIndex = this.students.findIndex(item => item.studentId === statusUpdate.studentId);
    if (currentStatusIndex !== -1) {
      this.students[studentIndex].status = this.badgeStatuses[currentStatusIndex].name;
      this.students[studentIndex].statusEn = this.badgeStatuses[currentStatusIndex].nameEn;
      this.students[studentIndex].color = this.badgeStatuses[currentStatusIndex].color;
      this.students[studentIndex].statusId = this.badgeStatuses[currentStatusIndex].id;
    }
    this.badgesUpdate();
  }
  badgesUpdate(): void {
    this.registerBadgeStatuses.map((item, index) => {
      if (index !== 0) item.value = this.students.filter(studentItem => studentItem.statusId === item.id).length;
    });
  }
  classUpdate(classItem: SchoolClass): void {
    this.class = classItem;
    if (classItem) {
      this.loaderActive = true;
      this.classesService.getclassSections(classItem.classId).subscribe(
        (data: Section[]) => {
          this.sections = data;
          if (this.dateParams) {
            this.attendanceSearchModel.date = this.dateParams;
            this.dateParams = null;
          }
          if (this.sectionIdParams) {
            this.attendanceSearchModel.sectionId = this.sectionIdParams;
            this.sectionIdParams = null;
            this.getSchoolDaysByClassSection();
          }
          this.loaderActive = false;
        },
        () => {
          this.loaderActive = false;
        }
      );
    }
    this.sections = [];
    this.sessions = [];
    this.periods = [];
  }
  getSchoolDaysByClassSection(): void {
    this.loaderActive = true;
    this.schoolDays = [];
    this.studyTableService.GetDaysByClassSection(this.attendanceSearchModel.classId, this.attendanceSearchModel.sectionId).subscribe(
      (data: CategoryDays) => {
        if (data) {
          data.days.map(items => {
            this.schoolDays.push(items.id - 1);
          });
          if (
            this.schoolDays.findIndex(item => item === moment(this.attendanceSearchModel.date).day()) === -1 &&
            this.schoolDays.length > 0
          ) {
            for (let index = 0; index < 7; index++) {
              this.attendanceSearchModel.date = moment(this.attendanceSearchModel.date)
                .locale('en')
                .add(-1, 'd')
                .format('YYYY-MM-DD');
              if (this.schoolDays.findIndex(item => item === moment(this.attendanceSearchModel.date).day()) !== -1) {
                break;
              }
            }
          }
          if (this.class) {
            this.getStudents();
            this.getSessions();
            this.getPeriods();
          }
          if (this.isFromLMS) this.getPeriods();
        }
        this.loaderActive = false;
      },
      () => {
        this.showWarning('AttendanceModule.ThisSectionNotLinkedWithAnyTimeTable');
        this.loaderActive = false;
      }
    );
  }
  attendanceSearchModelUpdate(attendanceSearchModel: AttendanceSearchModel): void {
    this.students = [];
    this.attendanceSearchModel = attendanceSearchModel;
    this.attendanceSearchModel.semesterId = this.mainFilterSvc.globalFilterObj.academicSemesterId;
    if (!this.attendanceSearchModel.attendanceSessionId) this.sessions = [];
    if (this.attendanceSearchModel.sectionId) this.getSchoolDaysByClassSection();
  }
  updatePeriodValue(attendanceSearchModel: AttendanceSearchModel): void {
    this.attendanceSearchModel = attendanceSearchModel;
    this.getStudents();
  }
  getSessions(): void {
    if (this.class.attendanceMethod === AttendanceMethodTypes.session && !this.attendanceSearchModel.attendanceSessionId) {
      this.loaderActive = true;
      this.attendanceServices.getAttendanceSessionsByClassId(this.class.classId).subscribe(
        (data: AttendanceSession[]) => {
          this.sessions = data;
          this.loaderActive = false;
        },
        () => {
          this.loaderActive = false;
        }
      );
    }
  }
  getPeriods(): void {
    if (
      (this.isFromLMS && this.attendanceSearchModel.date && this.attendanceSearchModel.schoolPeriodAllocationId === null) ||
      (!this.isFromLMS && this.class.attendanceMethod === AttendanceMethodTypes.subject &&
        this.attendanceSearchModel.date &&
        this.attendanceSearchModel.sectionId &&
        this.attendanceSearchModel.schoolPeriodAllocationId === null)
    ) {
      this.loaderActive = true;
      this.studyTableService
        .GetStudyTableByDate(
          this.attendanceSearchModel.classId,
          this.attendanceSearchModel.sectionId,
          moment(this.attendanceSearchModel.date)
            .locale('en')
            .format('MM-DD-YYYY')
        )
        .subscribe(
          (data: KeyValuePair<number, ScheduleCategoryAuto[]>[]) => {
            this.periods = [];
            Object.keys(data).map(key => {
              this.periods.push({
                periodId: Object.values(data)[key].schoolPeriodAllocationId,
                periodName: Object.values(data)[key].schedulePeriodName + ' - ' + Object.values(data)[key].subjectName,
                periodNameEn: Object.values(data)[key].schedulePeriodNameEn + ' - ' + Object.values(data)[key].subjectNameEn,
                sectionSubjectId: Object.values(data)[key].sectionSubjectId
              });
            });
            this.loaderActive = false;
          },
          () => {
            this.periods = [];
            this.showError('AttendanceModule.ErrorWhileGettingPeriods');
            this.loaderActive = false;
          }
        );
    } else if (this.isFromLMS && this.attendanceSearchModel.date && this.attendanceSearchModel.schoolPeriodAllocationId !== null) {
      this.getStudents();
    }
  }
  getStudents(): void {
    if (this.class && this.class.attendanceMethod === AttendanceMethodTypes.day && this.attendanceSearchModel.sectionId) {
      this.loaderActive = true;
      this.isBusy = true;
      this.attendanceServices.getAttendanceStudents(this.attendanceSearchModel).subscribe(
        (data: AttendanceRegister) => {
          this.students = data.students;
          this.isHoliday = data.isHoliday;
          this.isBusy = false;
          this.badgesInit();
        },
        () => {
          this.loaderActive = false;
          this.isBusy = false;
        }
      );
    } else if (
      this.class &&
      this.class.attendanceMethod === AttendanceMethodTypes.session &&
      this.attendanceSearchModel.attendanceSessionId
    ) {
      this.loaderActive = true;
      this.attendanceServices.getAttendanceStudents(this.attendanceSearchModel).subscribe(
        (data: AttendanceRegister) => {
          this.students = data.students;
          this.isHoliday = data.isHoliday;
          this.badgesInit();
        },
        () => {
          this.loaderActive = false;
        }
      );
    }
    if (
      this.isFromLMS ||
      (this.class.attendanceMethod === AttendanceMethodTypes.subject && this.attendanceSearchModel.schoolPeriodAllocationId !== null)
    ) {
      this.loaderActive = true;
      this.attendanceServices.getAttendanceStudents(this.attendanceSearchModel).subscribe(
        (data: AttendanceRegister) => {
          this.students = data.students;
          this.isHoliday = data.isHoliday;
          this.badgesInit();
        },
        () => {
          this.loaderActive = false;
        }
      );
    }
  }
  saving(): void {
    this.registerAttendanceModel = {
      isHoliday: this.isHoliday,
      students: [],
      attendanceSearch: this.attendanceSearchModel
    };
    if (!this.isHoliday)
      this.students.map(item => {
        if (item.statusId !== this.presentStatusId)
          this.registerAttendanceModel.students.push({
            studentId: item.studentId,
            statusId: item.statusId,
            comment: item.comment,
            isNotefied: this.isNotified
          });
      });
    this.loaderActive = true;
    this.attendanceServices.registerAttendance(this.registerAttendanceModel).subscribe(
      () => {
        // this.attendanceSearchModel = {
        //   attendanceSessionId: null,
        //   classId: null,
        //   date: moment()
        //     .locale('en')
        //     .format('YYYY-MM-DD'),
        //   sectionId: null,
        //   schoolPeriodAllocationId: null,
        //   semesterId: this.mainFilterSvc.globalFilterObj.academicSemesterId
        // };
        // this.students = [];
        // this.class = null;
        // this.isNotified = false;
        this.showSuccess('AttendanceModule.AttendanceSavedSuccessfully');
        this.loaderActive = false;
      },
      () => {
        this.showError('AttendanceModule.ErrorWhileSavingAttendance');
        this.loaderActive = false;
      }
    );
  }
  reset(): void {
    const that = this;
    const fun = function() {
      // BaseComponent.spinner.isActive = true;
      that.students = [];
      that.getStudents();
    };
    this.showConfirmYesNoMessage('AreYouSureYouWantToReset?', 'Confirm', fun);
  }
}
